import HourlyForecast from 'features/Weather/features/Forecast/widgets/HourlyForecastWidget/HourlyForecastWidget';
import FireDanger from 'features/Weather/features/SpecialReports/features/FireDanger/index.web';
import AirportDelays from 'features/Weather/features/SpecialReports/features/AirportDelays/index.web';
import SkiReports from 'features/Weather/features/SpecialReports/features/SkiReports/index.web';
import Alerts from 'pages/Weather/Alerts';
import Charts from 'pages/Weather/Charts';
import Maps from 'pages/Weather/Maps';
import MarineForecast from 'pages/Weather/MarineForecast/MarineForecast';
import {
    SIZES_ALL,
    SIZES_GRAPH,
    SIZES_TALL,
    SIZES_TALL_WIDE,
    SIZES_WIDE_ONLY,
    SIZES_WIDE_TALL,
    createWidgetMetaHelpers,
    iconImage,
    sidebarDataFor,
} from './widgetHelpers';

// Widget metadata pulls in assets and uses helpers to keep entries compact.
import chartsIcon from 'assets/nIcons/Charts.png';
import connectedDevicesIcon from 'assets/nIcons/Connected Devices.png';
import createAlertIcon from 'assets/nIcons/Create Alert.png';
import forecastIcon from 'assets/nIcons/Forecast.png';
import fullMapIcon from 'assets/nIcons/Maps.png';
import marineForecastIcon from 'assets/nIcons/Marine Forecast.png';
import overwatchIcon from 'assets/nIcons/Overwatch.png';
import specialReportsIcon from 'assets/nIcons/Special Reports.png';
import stormCenterIcon from 'assets/nIcons/Storm Center.png';
import { default as publicAlertsIcon, default as weatherAlertsIcon } from 'assets/nIcons/Weather Alerts.png';

//////////////// WIDGET PREVIEW IMAGES  /////////////////////////////////////////////////////////////////////////////////////////////////////////////
// // Weather
// Maps
import CurrentConditions1x1 from 'assets/WidgetPNGS/Weather/Maps/CurrentConditions1x1.png';
import CurrentConditions1x2 from 'assets/WidgetPNGS/Weather/Maps/CurrentConditions1x2.png';
import CurrentConditions2x1 from 'assets/WidgetPNGS/Weather/Maps/CurrentConditions2x1.png';
import Doppler1x1 from 'assets/WidgetPNGS/Weather/Maps/Doppler1x1.png';
import Doppler1x2 from 'assets/WidgetPNGS/Weather/Maps/Doppler1x2.png';
import Doppler2x1 from 'assets/WidgetPNGS/Weather/Maps/Doppler2x1.png';
import Earthquake1x1 from 'assets/WidgetPNGS/Weather/Maps/Earthquake1x1.png';
import Earthquake1x2 from 'assets/WidgetPNGS/Weather/Maps/Earthquake1x2.png';
import Earthquake2x1 from 'assets/WidgetPNGS/Weather/Maps/Earthquake2x1.png';
import SevereWeather1x1 from 'assets/WidgetPNGS/Weather/Maps/SevereWeather1x1.png';
import SevereWeather1x2 from 'assets/WidgetPNGS/Weather/Maps/SevereWeather1x2.png';
import SevereWeather2x1 from 'assets/WidgetPNGS/Weather/Maps/SevereWeather2x1.png';

//Forecast
import AirQualityForecast1x1Preview from 'assets/WidgetPNGS/Weather/Forecast/AirQualityForecast1x1Preview.png';
import AirQualityForecast1x2Preview from 'assets/WidgetPNGS/Weather/Forecast/AirQualityForecast1x2Preview.png';
import AirQualityForecast2x1Preview from 'assets/WidgetPNGS/Weather/Forecast/AirQualityForecast2x1Preview.png';
import AirQualityObservations1x1Preview from 'assets/WidgetPNGS/Weather/Forecast/AirQualityObservations1x1Preview.png';
import AirQualityObservations1x2Preview from 'assets/WidgetPNGS/Weather/Forecast/AirQualityObservations1x2Preview.png';
import AirQualityObservations2x1Preview from 'assets/WidgetPNGS/Weather/Forecast/AirQualityObservations2x1Preview.png';
import Day15Forecast1x1Preview from 'assets/WidgetPNGS/Weather/Forecast/Day15Forecast1x1Preview.png';
import Day15Forecast1x2Preview from 'assets/WidgetPNGS/Weather/Forecast/Day15Forecast1x2Preview.png';
import Day15Forecast2x1Preview from 'assets/WidgetPNGS/Weather/Forecast/Day15Forecast2x1Preview.png';
import DetailedForecast1x1Preview from 'assets/WidgetPNGS/Weather/Forecast/DetailedForecast1x1Preview.png';
import DetailedForecast1x2Preview from 'assets/WidgetPNGS/Weather/Forecast/DetailedForecast1x2Preview.png';
import DetailedForecast2x1Preview from 'assets/WidgetPNGS/Weather/Forecast/DetailedForecast2x1Preview.png';
import HourlyForecast1x1Preview from 'assets/WidgetPNGS/Weather/Forecast/HourlyForecast1x1Preview.png';
import HourlyForecast1x2Preview from 'assets/WidgetPNGS/Weather/Forecast/HourlyForecast1x2Preview.png';
import HourlyForecast2x1Preview from 'assets/WidgetPNGS/Weather/Forecast/HourlyForecast2x1Preview.png';


//StormCenter
import HurricanesTropicalStorms1x1 from 'assets/WidgetPNGS/Weather/StormCenter/Hurricanes1x1.png';
import HurricanesTropicalStorms1x2 from 'assets/WidgetPNGS/Weather/StormCenter/Hurricanes1x2.png';
import HurricanesTropicalStorms2x1 from 'assets/WidgetPNGS/Weather/StormCenter/Hurricanes2x1.png';
import MyAdvisories1x1 from 'assets/WidgetPNGS/Weather/StormCenter/MyForecastAdvisories1x1.png';
import MyAdvisories1x2 from 'assets/WidgetPNGS/Weather/StormCenter/MyForecastAdvisories1x2.png';
import MyAdvisories2x1 from 'assets/WidgetPNGS/Weather/StormCenter/MyForecastAdvisories2x1.png';
import NWSAlerts1x1 from 'assets/WidgetPNGS/Weather/StormCenter/NWSAlerts1x1.png';
import NWSAlerts1x2 from 'assets/WidgetPNGS/Weather/StormCenter/NWSAlerts1x2.png';
import NWSAlerts2x1 from 'assets/WidgetPNGS/Weather/StormCenter/NWSAlerts2x1.png';

//MarineForecast
import BuoyConditions1x1 from 'assets/WidgetPNGS/Weather/MarineForecast/BuoyConditions1x1.png';
import BuoyConditions1x2 from 'assets/WidgetPNGS/Weather/MarineForecast/BuoyConditions1x2.png';
import BuoyConditions2x1 from 'assets/WidgetPNGS/Weather/MarineForecast/BuoyConditions2x1.png';
import SurfAlerts1x1 from 'assets/WidgetPNGS/Weather/MarineForecast/SurfAlerts1x1.png';
import SurfAlerts1x2 from 'assets/WidgetPNGS/Weather/MarineForecast/SurfAlerts1x2.png';
import SurfAlerts2x1 from 'assets/WidgetPNGS/Weather/MarineForecast/SurfAlerts2x1.png';
import TideTable1x1 from 'assets/WidgetPNGS/Weather/MarineForecast/TideTable1x1.png';
import TideTable1x2 from 'assets/WidgetPNGS/Weather/MarineForecast/TideTable1x2.png';
import TideTable2x1 from 'assets/WidgetPNGS/Weather/MarineForecast/TideTable2x1.png';
import WaveAndWindConditions1x1 from 'assets/WidgetPNGS/Weather/MarineForecast/WaveAndWind1x1.png';
import WaveAndWindConditions1x2 from 'assets/WidgetPNGS/Weather/MarineForecast/WaveAndWind1x2.png';
import WaveAndWindConditions2x1 from 'assets/WidgetPNGS/Weather/MarineForecast/WaveAndWind2x1.png';

//Charts
import Day15ForecastChart2x1 from 'assets/WidgetPNGS/Weather/Charts/15DayForecastChart2x1.png';
import Day7ForecastChart2x1 from 'assets/WidgetPNGS/Weather/Charts/7DayForecastChart2x1.png';
import PrecipitationChart2x1Preview from 'assets/WidgetPNGS/Weather/Charts/ChanceOfPrecipitationChart2x1.png';
import ChanceOfPrecipitationChart2x1Preview from 'assets/WidgetPNGS/Weather/Charts/ChanceOfPrecipitationChart2x1.png';
import ComfortLevelChart2x1 from 'assets/WidgetPNGS/Weather/Charts/ComfortLevelChart2x1.png';
import DetailedForecastChart2x1 from 'assets/WidgetPNGS/Weather/Charts/DetailedForecastChart2x1.png';
import DewPointChart2x1 from 'assets/WidgetPNGS/Weather/Charts/DewPointChart2x1.png';
import HumidityChart2x1 from 'assets/WidgetPNGS/Weather/Charts/HumidityChart2x1.png';
import PressureChart2x1 from 'assets/WidgetPNGS/Weather/Charts/PressureChart2x1.png';
import TemperatureChart2x1 from 'assets/WidgetPNGS/Weather/Charts/TemperatureChart2x1.png';
import WindSpeedChart2x1 from 'assets/WidgetPNGS/Weather/Charts/WindSpeedChart2x1.png';

//Special Reports
import AirportDelay1x1 from 'assets/WidgetPNGS/Weather/SpecialReports/AirportDelays1x1.png';
import AirportDelay1x2 from 'assets/WidgetPNGS/Weather/SpecialReports/AirportDelays1x2.png';
import AirportDelay2x1 from 'assets/WidgetPNGS/Weather/SpecialReports/AirportDelays2x1.png';
import FireDanger1x1 from 'assets/WidgetPNGS/Weather/SpecialReports/FireDanger1x1.png';
import FireDanger1x2 from 'assets/WidgetPNGS/Weather/SpecialReports/FireDanger1x2.png';
import FireDanger2x1 from 'assets/WidgetPNGS/Weather/SpecialReports/FireDanger2x1.png';
import SkiReports1x1 from 'assets/WidgetPNGS/Weather/SpecialReports/SkiReports1x1.png';
import SkiReports1x2 from 'assets/WidgetPNGS/Weather/SpecialReports/SkiReports1x2.png';
import SkiReports2x1 from 'assets/WidgetPNGS/Weather/SpecialReports/SkiReports2x1.png';

//WeatherAlerts
import WeatherAlerts1x1 from 'assets/WidgetPNGS/Weather/WeatherAlerts/WeatherAlerts1x1.png';
import WeatherAlerts1x2 from 'assets/WidgetPNGS/Weather/WeatherAlerts/WeatherAlerts1x2.png';
import WeatherAlerts2x1 from 'assets/WidgetPNGS/Weather/WeatherAlerts/WeatherAlerts2x1.png';

// // Overwatch
import BuoyMap1x1 from 'assets/WidgetPNGS/Overwatch/BuoyMap1x1.png';
import BuoyMap1x2 from 'assets/WidgetPNGS/Overwatch/BuoyMap1x2.png';
import BuoyMap2x1 from 'assets/WidgetPNGS/Overwatch/BuoyMap2x1.png';
import ConnectedDeviceGroups1x2 from 'assets/WidgetPNGS/Overwatch/ConnectedDeviceGroups1x2.png';
import ConnectedDeviceGroups2x1 from 'assets/WidgetPNGS/Overwatch/ConnectedDeviceGroups2x1.png';
import ConnectedDevices1x2 from 'assets/WidgetPNGS/Overwatch/ConnectedDevices1x2.png';
import ConnectedDevicesGraph2x1 from 'assets/WidgetPNGS/Overwatch/ConnectedDevicesGraph2x1.png';
import TechnologyBridgeFlashingLights1x2 from 'assets/WidgetPNGS/Overwatch/FlashingLights1x2.png';
import TechnologyBridgeFlashingLights2x1 from 'assets/WidgetPNGS/Overwatch/FlashingLights2x1.png';
import FloodStage1x1 from 'assets/WidgetPNGS/Overwatch/FloodStage1x1.png';
import FloodStage1x2 from 'assets/WidgetPNGS/Overwatch/FloodStage1x2.png';
import FloodStage2x1 from 'assets/WidgetPNGS/Overwatch/FloodStage2x1.png';
import ManualRoadClosureDevices1x2 from 'assets/WidgetPNGS/Overwatch/ManualRoadClosure1x2.png';
import ManualRoadClosureDevices2x1 from 'assets/WidgetPNGS/Overwatch/ManualRoadClosure2x1.png';
import OverwatchVMS from 'assets/WidgetPNGS/Overwatch/OverwatchVMS2x1.png';
import TechnologyBridgeSiren2x1 from 'assets/WidgetPNGS/Overwatch/Siren2x1.png';
import TechnologyBridgeSiren1x2 from 'assets/WidgetPNGS/Overwatch/Sirenx1x2.png';
import USGSMap1x1 from 'assets/WidgetPNGS/Overwatch/USGSMap1x1.png';
import USGSMap1x2 from 'assets/WidgetPNGS/Overwatch/USGSMap1x2.png';
import USGSMap2x1 from 'assets/WidgetPNGS/Overwatch/USGSMap2x1.png';

// // Public Info
import ActiveAlerts1x1 from 'assets/WidgetPNGS/PublicInfo/ActiveAlerts1x1.png';
import ActiveAlerts1x2 from 'assets/WidgetPNGS/PublicInfo/ActiveAlerts1x2.png';
import ActiveAlerts2x1 from 'assets/WidgetPNGS/PublicInfo/ActiveAlerts2x1.png';
import CreateAlert1x2 from 'assets/WidgetPNGS/PublicInfo/CreateAlert1x2.png';
import CreateAlert2x1 from 'assets/WidgetPNGS/PublicInfo/CreateAlert2x1.png';
import AlertCreator from 'features/Weather/features/WeatherAlerts/features/AlertCreator/index.web';
import Integrations from 'pages/System/Integrations/Integrations';

//////////////// END OF WIDGET PREVIEW IMAGES  /////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////// END OF WIDGET PREVIEW IMAGES  /////////////////////////////////////////////////////////////////////////////////////////////////////////////

const {
  makeForecastWidget,
  makeStormCenterWidget,
  makeMarineForecastWidget,
  makeMapsWidget,
  makeChartWidget,
  makeSpecialReportWidget,
  makeConnectedDevicesWidgetMeta,
  makePublicInfoWidget,
} = createWidgetMetaHelpers({

  // These components are used as fullscreen destinations for widgets.
  Charts,
  HourlyForecast,
  MarineForecast,
  Maps,
  Integrations,
  icons: {
    chartsIcon,
    forecastIcon,
    stormCenterIcon,
    marineForecastIcon,
    fullMapIcon,
    specialReportsIcon,
    connectedDevicesIcon,
    publicAlertsIcon,
    createAlertIcon,
  },
});

// widgetMeta is pure config; render logic lives in widgetRenderers.js.
export const widgetMeta = {
    1: makeMapsWidget( // Severe Weather Warnings
      1, // id
      'SevereWeatherAlertsMap', // name
      'Severe Weather Warnings', // displayName
      {
        '1x1': SevereWeather1x1, // preview images
        '1x2': SevereWeather1x2, // preview images
        '2x1': SevereWeather2x1, // preview images
      },
      '/weather/maps?tab=Severe+Weather+Warnings' // fullscreen path
    ),
    2: {
      ...makeForecastWidget( // Weather Forecast
        2,
        'HourlyForecast',
        'Hourly Forecast',
        {
          '1x1': HourlyForecast1x1Preview,
          '1x2': HourlyForecast1x2Preview,
          '2x1': HourlyForecast2x1Preview,
        },
        '/weather/forecast?tab=Weather+Home'
      ),
      w: 1,
      h: 1,
    },
    3: makeMapsWidget( // Map Forecast - Current Conditions
      3,
      'MapForecast',
      'Current Conditions',
      {
        '1x1': CurrentConditions1x1,
        '1x2': CurrentConditions1x2,
        '2x1': CurrentConditions2x1,
      },
      '/weather/maps?tab=Current+Conditions'
    ),
    4: makeForecastWidget( // Detailed Forecast
      4,
      'DetailedForecast',
      'Detailed Forecast',
      {
        '1x1': DetailedForecast1x1Preview,
        '1x2': DetailedForecast1x2Preview,
        '2x1': DetailedForecast2x1Preview,
      },
      '/weather/forecast?tab=Detailed+Forecast'
    ),
    5: makeForecastWidget( // 15 Day Forecast
      5,
      'Day15Forecast',
      '15 Day Forecast',
      {
        '1x1': Day15Forecast1x1Preview,
        '1x2': Day15Forecast1x2Preview,
        '2x1': Day15Forecast2x1Preview,
      },
      '/weather/forecast?tab=15-Day+Forecast'
    ),
    6: makeForecastWidget( // Air Quality Observations
      6,
      'AirQualityObservations',
      'Air Quality Observations',
      {
        '1x1': AirQualityObservations1x1Preview,
        '1x2': AirQualityObservations1x2Preview,
        '2x1': AirQualityObservations2x1Preview,
      },
      '/weather/forecast?tab=Air+Quality&subtab=Air+Quality+Observations'
    ),
    7: makeForecastWidget( // Air Quality Forecast
      7,
      'AirQualityForecast',
      'Air Quality Forecast',
      {
        '1x1': AirQualityForecast1x1Preview,
        '1x2': AirQualityForecast1x2Preview,
        '2x1': AirQualityForecast2x1Preview,
      },
      '/weather/forecast?tab=Air+Quality&subtab=Air+Quality+Forecast'
    ),
    8: makeStormCenterWidget( // NWS Alerts
      8,
      'NWSAlerts',
      'NWS Alerts',
      {
        '1x1': NWSAlerts1x1,
        '1x2': NWSAlerts1x2,
        '2x1': NWSAlerts2x1,
      },
      '/weather/stormcenter?tab=NWS+Alerts'
    ),
    9: makeStormCenterWidget( // My Forecast Advisories
      9,
      'MyAdvisories',
      'My Forecast Advisories',
      {
        '1x1': MyAdvisories1x1,
        '1x2': MyAdvisories1x2,
        '2x1': MyAdvisories2x1,
      },
      '/weather/stormcenter?tab=My+Forecast+Advisories'
    ),
    10: makeMarineForecastWidget( // Wave and Wind Conditions
      10,
      'WaveAndWindConditions',
      'Wave and Wind Conditions',
      {
        '1x1': WaveAndWindConditions1x1,
        '1x2': WaveAndWindConditions1x2,
        '2x1': WaveAndWindConditions2x1,
      },
      '/weather/marineforecast?tab=Wave+and+Wind+Conditions'
    ),
    11: makeMarineForecastWidget( // Surf Alerts
      11,
      'SurfAlerts',
      'Surf Alerts',
      {
        '1x1': SurfAlerts1x1,
        '1x2': SurfAlerts1x2,
        '2x1': SurfAlerts2x1,
      },
      '/weather/marineforecast?tab=Surf+Alerts'
    ),
    12: makeMarineForecastWidget( // Buoy Conditions
      12,
      'BuoyConditions',
      'Buoy Conditions',
      {
        '1x1': BuoyConditions1x1,
        '1x2': BuoyConditions1x2,
        '2x1': BuoyConditions2x1,
      },
      '/weather/marineforecast?tab=Buoy+Conditions'
    ),
    13: makeMarineForecastWidget( // Tide Table
      13,
      'TideTable',
      'Tide Table',
      {
        '1x1': TideTable1x1,
        '1x2': TideTable1x2,
        '2x1': TideTable2x1,
      },
      '/weather/marineforecast?tab=Tide+Table'
    ),
    14: makeMapsWidget( // Earthquake Map
      14,
      'Earthquake',
      'Earthquake',
      {
        '1x1': Earthquake1x1,
        '1x2': Earthquake1x2,
        '2x1': Earthquake2x1,
      },
      '/weather/maps?tab=Earthquake',
    ),
    15: {
      ...makeStormCenterWidget( // Hurricanes & Tropical Storms
        15,
        'HurricanesTropicalStorms',
        'Hurricanes & Tropical Storms',
        {
          '1x1': HurricanesTropicalStorms1x1,
          '1x2': HurricanesTropicalStorms1x2,
          '2x1': HurricanesTropicalStorms2x1,
        },
        '/weather/stormcenter?tab=Hurricanes+and+Tropical+Storms'
      ),
      contentType: 'map',
      sizes: SIZES_ALL,
    },

    16: makeChartWidget( // Detailed Forecast Chart
      16,
      'Charts-DetailedForecast',
      'Detailed Forecast Chart',
      null,
      DetailedForecastChart2x1,
      '/weather/charts?tab=5-Day+Detailed+Forecast'
    ),
    17: makeChartWidget( // 7 Day Forecast Chart
      17,
      'Charts-7DayForecast',
      '7 Day Forecast Chart',
      null,
      Day7ForecastChart2x1,
      '/weather/charts?tab=7-Day+Hourly+Forecast'
    ),
    18: makeChartWidget( // 15 Day Forecast Chart
      18,
      'Charts-15DayForecast',
      '15 Day Forecast Chart',
      null,
      Day15ForecastChart2x1,
      '/weather/charts?tab=15-Day+Forecast'
    ),
    19: makeChartWidget( // Chance of Precipitation Chart
      19,
      'Charts-ChanceOfPrecip',
      'Chance of Precipitation Chart',
      null,
      ChanceOfPrecipitationChart2x1Preview,
      '/weather/charts?tab=Chance+of+Precipitation'
    ),
    20: makeChartWidget( // Comfort Level Chart
      20,
      'Charts-ComfortLevel',
      'Comfort Level Chart',
      null,
      ComfortLevelChart2x1,
      '/weather/charts?tab=Comfort+Level'
    ),
    21: makeChartWidget( // Dew Point Chart
      21,
      'Charts-DewPoint',
      'Dew Point Chart',
      null,
      DewPointChart2x1,
      '/weather/charts?tab=Dew+Point'
    ),
    22: makeChartWidget( // Humidity Chart
      22,
      'Charts-Humidity',
      'Humidity Chart',
      null,
      HumidityChart2x1,
      '/weather/charts?tab=Humidity'
    ),
    23: makeChartWidget( // Pressure Chart
      23,
      'Charts-Pressure',
      'Pressure Chart',
      null,
      PressureChart2x1,
      '/weather/charts?tab=Pressure'
    ),
    24: makeChartWidget( // Precipitation Chart
      24,
      'Charts-Precipitation',
      'Precipitation Chart',
      null,
      PrecipitationChart2x1Preview,
      '/weather/charts?tab=Precipitation'
    ),
    25: makeChartWidget( // Temperature Chart
      25,
      'Charts-Temperature',
      'Temperature Chart',
      null,
      TemperatureChart2x1,
      '/weather/charts?tab=Temperature'
    ),
    26: makeChartWidget( // Wind Speed Chart
      26,
      'Charts-WindSpeed',
      'Wind Speed Chart',
      null,
      WindSpeedChart2x1,
      '/weather/charts?tab=Wind+Speed'
    ),

    27: makeSpecialReportWidget( // Fire Danger
      27,
      'FireDanger',
      'Fire Danger',
      FireDanger1x1,
      FireDanger1x2,
      FireDanger2x1,
      '/weather/specialreports?tab=Fire+Danger',
      FireDanger,
    ),
    28: makeSpecialReportWidget( // Airport Delays
      28,
      'AirportDelay',
      'Airport Delays',
      AirportDelay1x1,
      AirportDelay1x2,
      AirportDelay2x1,
      '/weather/specialreports?tab=Airport+Delay',
      AirportDelays,
    ),
    29: makeSpecialReportWidget( // Ski Reports
      29,
      'SkiReport',
      'Ski Reports',
      SkiReports1x1,
      SkiReports1x2,
      SkiReports2x1,
      '/weather/specialreports?tab=Ski+Reports',
      SkiReports,
    ),
    30: makeConnectedDevicesWidgetMeta( // Flood Stage Graph / USGS Graph
      30,
      'FloodStageGraph',
      'Connected Devices Graph',
      SIZES_GRAPH,
      { '2x1': ConnectedDevicesGraph2x1 },
      ['SystemEnabled', 'IntegrationsEnabled', 'ViewFloodStageConnections'],
      '/system/devices?tab=Connected+Devices',
      Integrations
    ),
    31: makeConnectedDevicesWidgetMeta( // Flood Stage Map
      31,
      'FloodStageMap',
      'Flood Stage Map',
      SIZES_ALL,
      {
        '1x1': FloodStage1x1,
        '2x1': FloodStage2x1,
        '1x2': FloodStage1x2,
      },
      ['SystemEnabled', 'IntegrationsEnabled', 'ViewFloodStageConnections'],
      '/system/devices?tab=Connected+Devices',
      Integrations,
      'map'
    ),
    32: makeMapsWidget( // Doppler Map
      32,
      'DopplerMap',
      'Doppler Map',
      {
        '1x1': Doppler1x1,
        '1x2': Doppler1x2,
        '2x1': Doppler2x1,
      },
      '/weather/maps?tab=Doppler'
    ),
    33: {             // Weather Alerts with custom filter
      id: 33,
      name: 'WeatherAlerts',
      displayName: 'Weather Alerts',
      isResizable: false,
      sizes: SIZES_ALL,
      previewImages: {
        '1x1': WeatherAlerts1x1,
        '1x2': WeatherAlerts1x2,
        '2x1': WeatherAlerts2x1,
      },
      fullscreen: () => (
        <Alerts
          filterAlerts={(list) =>
            list.filter((item) => item.provider === 'Custom Weather')
          }
        />
      ),
      sidebarData: sidebarDataFor('/weather/alerts'),
      category: ['Weather', 'Weather Alerts'],
      icon: iconImage(weatherAlertsIcon),
      permissions: ['WeatherEnabled', 'WeatherAlerts'],
    },
    34: makeConnectedDevicesWidgetMeta( // Technology Bridge Flashing Lights Devices
      34,
      'TechnologyBridgeFlashingLightsDevices',
      'RescAlert Flashing Lights Map',
      SIZES_WIDE_TALL,
      {
        '1x2': TechnologyBridgeFlashingLights1x2,
        '2x1': TechnologyBridgeFlashingLights2x1,
      },
      [
        'SystemEnabled',
        'IntegrationsEnabled',
        'ViewRescAlertDevicesTechnologyBridge_FlashingLightsConnections',
      ],
      '/system/devices?tab=Connected+Devices',
      Integrations,
      'map'
    ),
    35: makeConnectedDevicesWidgetMeta( // Manual Road Closure Devices
      35,
      'ManualRoadClosureDevices',
      'RescAlert Manual Road Closures Map',
      SIZES_WIDE_TALL,
      {
        '1x2': ManualRoadClosureDevices1x2,
        '2x1': ManualRoadClosureDevices2x1,
      },
      [
        'SystemEnabled',
        'IntegrationsEnabled',
        'ViewRescAlertDevicesManualRoadClosureConnections',
      ],
      '/system/devices?tab=Connected+Devices',
      Integrations,
      'map'
    ),
    36: makeConnectedDevicesWidgetMeta( // Technology Bridge Siren/Giant Voice Devices
      36,
      'TechnologyBridgeSirenDevices',
      'RescAlert Siren/Giant Voice Map',
      SIZES_WIDE_TALL,
      {
        '1x2': TechnologyBridgeSiren1x2,
        '2x1': TechnologyBridgeSiren2x1,
      },
      [
        'SystemEnabled',
        'IntegrationsEnabled',
        'ViewRescAlertDevicesTechnologyBridge_Siren-GiantVoiceConnections',
      ],
      '/system/devices?tab=Connected+Devices',
      Integrations,
      'map'
    ),
    37: makeConnectedDevicesWidgetMeta( // Connected Devices
      37,
      'ConnectedDevices',
      'Connected Devices',
      SIZES_TALL,
      { '1x2': ConnectedDevices1x2 },
      ['SystemEnabled', 'IntegrationsEnabled'],
      '/system/devices?tab=Connected+Devices',
      Integrations
    ),
    38: makeConnectedDevicesWidgetMeta( // Connected Device Groups
      38,
      'ConnectedDeviceGroups',
      'Connected Device Groups',
      SIZES_WIDE_TALL,
      {
        '1x2': ConnectedDeviceGroups1x2,
        '2x1': ConnectedDeviceGroups2x1,
      },
      [
        'SystemEnabled',
        'IntegrationsEnabled',
        'ViewDeviceGroups',
      ],
      '/system/devices?tab=Connected+Device+Groups'
    ),
    39: makeConnectedDevicesWidgetMeta( //USGS Monitoring Station Map Widget
      39,
      'USGSDeviceMap',
      'USGS Monitoring Station Map',
           SIZES_ALL,
      {
        '1x1': USGSMap1x1,
        '2x1': USGSMap2x1,
        '1x2': USGSMap1x2,
      },
      ['SystemEnabled', 'IntegrationsEnabled', 'ViewUSGSMonitoringStationConnections'],
      '/weather/usgs-map',
      Integrations,
      'map'
    ),
    101: makePublicInfoWidget( // Active Alerts
      101,
      'ActiveAlerts',
      'Active Alerts',
      SIZES_ALL,
      {
        '1x1': ActiveAlerts1x1,
        '1x2': ActiveAlerts1x2,
        '2x1': ActiveAlerts2x1,
      },
      '/publicuser/alerts',
      ['PublicInfoEnabled', 'ViewAlerts'],
      Alerts
    ),
    102: makePublicInfoWidget( // Create Alert
      102,
      'CreateAlert',
      'Create Alert',
      SIZES_TALL_WIDE,
      {
        '1x2': CreateAlert1x2,
        '2x1': CreateAlert2x1,
      },
      '/publicuser/createalert',
      ['PublicInfoEnabled', 'Create-EditAlerts'],
      AlertCreator
    ),
    103: 
    {                  // Overwatch VMS
      id: 103,
      name: 'OverwatchVMS',
      displayName: 'Overwatch VMS',
      isResizable: false,
      sizes: SIZES_WIDE_ONLY,
      previewImages: { '2x1': OverwatchVMS },
      category: ['Overwatch', 'Connected Devices'],
      sidebarData: sidebarDataFor('/vms'),
      icon: iconImage(overwatchIcon),
      permissions: ['SystemEnabled', 'IntegrationsEnabled', 'ViewExacqVisionOverwatchVMSConnections'],
    },
    104: makeConnectedDevicesWidgetMeta( // Buoy Map
      104,
      'BuoyMap',
      'Buoy Map',
      SIZES_ALL,
      {
        '1x1': BuoyMap1x1,
        '2x1': BuoyMap2x1,
        '1x2': BuoyMap1x2,
      },
      ['SystemEnabled', 'IntegrationsEnabled', 'ViewRescAlertDevicesBuoyConditionsConnections'],
      '/weather/maps?tab=Buoy+Map',
      Integrations,
      'map'
    ),
};
